module.exports = __webpack_public_path__ + "step5_F2M_kanai_bridal.75f34cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_F2M_kanai_bridal.jpg
// module id = ARra
// module chunks = 0